import styled from 'styled-components';

type CarProps = {
  isNew?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
};

// eslint-disable-next-line eag/no-css-property
export const Car = styled.div<CarProps>`
  display: grid;
  grid-template-columns: 240px auto;
  border-radius: ${({theme}) => theme.radii.small};
  border: 2px solid transparent;

  &.active-iframe {
    border-color: ${({theme}) => theme.colors.palettes.blue[60][100]};
  }

  ${({isLoading}) => isLoading && `display: block;`};

  @media only screen and (max-width: ${({theme}) => theme.breakPoints.MEDIUM_UP}) {
    height: 250px;
  }

  @media only screen and (max-width: ${({theme}) => theme.breakPoints.SMALL_UP}) {
    height: auto;
    display: flex;
    flex-direction: column;
  }

  ${({isNew, theme}) => isNew && `background-color: ${theme.colors.palettes.green[20][100]};`}

  ${({isDisabled}) =>
    isDisabled &&
    `
    opacity: 0.5;
    filter: grayscale(1);
  `}
`;
